import { Component, OnInit } from '@angular/core';
import { ACADEMIC_GALLERY } from '../../../constant/auto/academic_gallery.constant';
import { CULTURAL_GALLERY } from '../../../constant/auto/cultural_gallery.constant';
import { SPORTS_GALLERY } from '../../../constant/auto/sports_gallery.constant';

interface GalleryImage {
  displayText: string;
  filename: string;
  link: string;
}

interface Category {
  name: string;
  images: GalleryImage[];
}

@Component({
  standalone: false,
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.css']
})
export class GalleryComponent implements OnInit {
  categories: Category[] = [
    { name: 'Academic', images: ACADEMIC_GALLERY },
    { name: 'Cultural', images: CULTURAL_GALLERY },
    { name: 'Sports', images: SPORTS_GALLERY }
  ];

  selectedCategory: Category;
  selectedImage: GalleryImage | null = null;
  selectedImageIndex = 0;
  isLoading = false;

  constructor() {
    this.selectedCategory = this.categories[0];
  }

  ngOnInit(): void {
    // Pre-load images for better user experience
    this.categories.forEach(category => {
      category.images.forEach(image => {
        const img = new Image();
        img.src = image.filename;
      });
    });
  }

  selectCategory(category: Category): void {
    this.selectedCategory = category;
    this.selectedImage = null;
    this.selectedImageIndex = 0;
  }

  getCategoryIcon(index: number): string {
    const icons = ['fa-graduation-cap', 'fa-music', 'fa-futbol'];
    return icons[index] || 'fa-image';
  }

  displayImage(image: GalleryImage, index: number): void {
    this.selectedImage = image;
    this.selectedImageIndex = index;
    this.isLoading = true;
    
    // Manually trigger Bootstrap modal
    setTimeout(() => {
      const modalElement = document.getElementById('galleryModal');
      if (modalElement) {
        const modal = new (window as any).bootstrap.Modal(modalElement);
        modal.show();
      }
    }, 0);
  }

  onImageLoad(event: Event): void {
    this.isLoading = false;
  }

  prevImage(): void {
    const images = this.selectedCategory.images;
    this.isLoading = true;
    this.selectedImageIndex = this.selectedImageIndex === 0 ? images.length - 1 : this.selectedImageIndex - 1;
    this.selectedImage = images[this.selectedImageIndex];
  }

  nextImage(): void {
    const images = this.selectedCategory.images;
    this.isLoading = true;
    this.selectedImageIndex = this.selectedImageIndex === images.length - 1 ? 0 : this.selectedImageIndex + 1;
    this.selectedImage = images[this.selectedImageIndex];
  }

  handleKeyboardNavigation(event: KeyboardEvent): void {
    if (this.selectedImage) {
      if (event.key === 'ArrowLeft') {
        this.prevImage();
      } else if (event.key === 'ArrowRight') {
        this.nextImage();
      } else if (event.key === 'Escape') {
        this.selectedImage = null;
      }
    }
  }
}
